import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import Resume from './pages/Resume';
import Projects from './pages/Projects';
import TicTacToe from './pages/TicTacToe';
import Connect4 from './pages/Connect4';
import Wishlist from './pages/Wishlist';
import Scheduling from './pages/Scheduling';
import Payments from './pages/Payments';
import Shop from './pages/Shop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-gray-50 text-gray-800">
        <Navbar />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/resume.html" element={<Resume />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects.html" element={<Projects />} />
            <Route path="/projects/tic-tac-toe" element={<TicTacToe />} />
            <Route path="/projects/tic-tac-toe.html" element={<TicTacToe />} />
            <Route path="/projects/connect-4" element={<Connect4 />} />
            <Route path="/projects/connect-4.html" element={<Connect4 />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/wishlist.html" element={<Wishlist />} />
            <Route path="/contact" element={<Scheduling />} />
            <Route path="/contact.html" element={<Scheduling />} />
            <Route path="/scheduling" element={<Scheduling />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/payments.html" element={<Payments />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop.html" element={<Shop />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
